// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"ca550c9f59e2c8f9","242":"64cbb84d5ddfb2c6","488":"62c0f60dc50d9168","602":"f09ae8c485cb4989","623":"80600496dede4c86"}[chunkId] + ".js";
};